/**
 * Script Loader.
 *
 * @format
 * @param {string} scriptSrc
 * @param {string} scriptName
 * @param {Function} callback
 */

export const scriptLoader = (
  scriptSrc: string,
  scriptName: string,
  callback?: () => void
): void => {
  const loadScript: HTMLScriptElement = document.createElement('script');
  loadScript.type = 'text/javascript';
  // loadScript.crossOrigin = '';
  loadScript.async = true;
  loadScript.src = scriptSrc;
  loadScript.id = scriptName;
  document.body.appendChild(loadScript);

  /**
   * Callback.
   * Fire callback when script is loaded.
   */
  if (callback) {
    if (loadScript.readyState) {
      loadScript.onreadystatechange = () => {
        if (
          loadScript.readyState === 'loaded' ||
          loadScript.readyState === 'complete'
        ) {
          loadScript.onreadystatechange = null;
          callback();
        }
      };
    } else {
      loadScript.onload = () => {
        callback();
      };
    }
  }
};

/**
 * Load Third Pary Scripts.
 * Setup TrustE and Google Tag Manager.
 */
export const loadThirdPartyScripts = (): void => {
  /**
   * Load Google Tage Manger.
   */
  const loadGoogleTagManager = (gtmId: string): void => {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gtmId);
  };

  /**
   * TruestE.
   */
  const loadTrustE = (): void => {
    scriptLoader(
      '//consent.truste.com/notice?domain=varian.com&c=teconsent&js=nj&noticeType=bb&gtm=1',
      'truste-gtm',
      (): void => {
        loadGoogleTagManager('GTM-59ZFRJN');
      }
    );
  };
  loadTrustE();
};
